import type { RegSettingOption } from "@offstreetparking/portal-flow/types/entry-points";
import type { PortalV2RegistrationSetting, PortalV2Tenant } from "~/services/portalV2Api/types";

export function normalizeRegSettings({
	settings,
	tenantRegSettingIds,
	disabledSettings,
}: {
	settings: PortalV2RegistrationSetting[];
	tenantRegSettingIds: (number | string)[];
	disabledSettings: PortalV2Tenant["disabledSettings"];
}): RegSettingOption[] {
	const settingIds = tenantRegSettingIds.map((id) => Number(id));

	return settings
		.filter((setting) => settingIds.includes(setting.id))
		.filter((setting) => setting.wizardSettings.settingIsAvailable)
		.map((setting) => ({
			id: setting.id,
			name: setting.name,
			description: setting.description,
			isAvailable: setting.wizardSettings.settingIsAvailable,
			isAtCapacity:
				disabledSettings?.some((d) => d.settingId === setting.id && d.maxRegistrationsReached) ?? false,
		}));
}
